import SLabel from './s-label'

export default SLabel
